import React from 'react';
import ColorBox from '../../../element/colorbox';
import Title from '../../../element/title';
import clone from 'clone';
import url from '../../../urlhandler/urlHandlerActions';
import { findIndex } from 'underscore';

const $ = jQuery;
const RE = REBUILDER;

class ColorBoxPreview extends React.Component {
  constructor(props) {
    super(props);
    this.handleColorBoxvalue = this.handleColorBoxvalue.bind(this);
    this.metakey = '_reactive_builder_' + this.props.shortcodeKey;

    this.state = {
      'values': [],
      'options': [],
      'toogle': true,
    };
    this.changeToogle = this.changeToogle.bind(this);
  }
  componentWillReceiveProps(nextprops) {
    this.block = nextprops.block;
  }
  handleColorBoxvalue(values) {
    this.setState({ 'values': _.pluck(values, 'slug') });
    url.push({
      'searchItem': this.searchItem,
      'searchType': this.searchType,
      'searchField': 'colorBox',
      values,
    });
  }
  changeToogle() {
    const toogle = !this.state.toogle;
    this.setState({ toogle });
  }
  render() {
    this.helperData = clone(this.props.helperData);
    this.block = this.props.block;
    let values = this.state.values;
    const urlData = this.props.urlData;
    if (urlData.hasOwnProperty('pagenumber')) {
      delete urlData['pagenumber'];
    }
    if (this.block.selectedDataType !== null) {
      // taxonomies
      if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
        const previousOptions = this.options;
        this.options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
        this.searchType = 'taxonomies';
        this.searchItem = this.block.selectedTaxonomy;
        const allUrlData = [];
        window.searchArray.map((item) => {
          if (item.key.toString() !== 'pagenumber' && item.key.toString() !== 'view') {
            allUrlData.push(item);
          }
        });
        const topKey = allUrlData.length !== 0 ? allUrlData[allUrlData.length - 1].key : null;
        let tempOptions = [];
        if (topKey !== null && this.filterable !== true) {
          let selectedOptions = [];
          const self = this;
          if (this.searchItem !== topKey) {
            // the searchItem is not the top
            if (urlData.hasOwnProperty(self.searchItem)) {
              if (!(_.isArray(urlData[self.searchItem]))) {
                selectedOptions.push(urlData[self.searchItem]); // previous selected Options
              } else {
                selectedOptions = clone(urlData[self.searchItem]);
              }
            }
            this.options.map((item) => {
              this.props.previewData.data.map((singleItem) => {
                const isAlreadyATakenOption = findIndex(tempOptions, { slug: item.slug });
                const optionIndex = _.indexOf(singleItem.terms[this.searchItem], item.slug);;
                if ((optionIndex !== -1 && isAlreadyATakenOption === -1)) {
                  tempOptions.push(item);
                }
              });
              const selectedIndex = _.indexOf(selectedOptions, item.slug);
              if (selectedIndex !== -1) {
                const temp = [];
                temp.push(item);
                tempOptions = _.union(tempOptions, temp);
              }
            });
            this.options = clone(tempOptions);
          } else {
            if (Object.keys(urlData).length === 1) {
              this.options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
            }
            if (Object.keys(urlData).length !== 1) {
              if (previousOptions !== undefined) {
                this.options = clone(previousOptions);
              }
            }
          }
        }
      } else {
        this.options = this.props.helperData.metadata[this.block.selectedMetakey] ? this.helperData.metadata[this.block.selectedMetakey] : [];
        this.searchType = 'metakeys';
        this.searchItem = this.block.selectedMetakey;
      }

      // url case
      if (this.props.urlData.hasOwnProperty(this.searchItem)) {
        // if (this.state.values.length < 1) {
        values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
        // }
      } else {
        values = [];
      }
    }
    const ifOpen = this.state.toogle ? 'active' : 'toggle-option';
    const colorBoxClassName = this.props.block.dynamicNameClassCheckBox;
    const HelperClass = this.state.toogle ? 'single-component' : '';
    return (<div className={colorBoxClassName}>
        <Title
          title={this.props.block.title}
          subtitle={this.props.block.subtitle}
          toogle= {this.state.toogle}
          onToogle = {this.changeToogle}
          selectedToogleViewType = {this.props.block.selectedToogleViewType}
        />
        <div className={HelperClass}>
        {this.options !== undefined && this.options.length ?
          <div>
            <ColorBox
              isOpenElement={ifOpen}
              options={this.options}
              setColumn={this.props.block.setColumn}
              showItemColorName={this.props.block.showItemColorName}
              value={values}
              onSelectColorBox={this.handleColorBoxvalue}
              block={this.block}
            />
          </div> : null}
          {this.options.length === 0 && this.state.toogle ?
            <div className={'rq-no-attributes-found' + ' ' + ifOpen}>
              <h3>{API.LANG.NO_ATTR_FOUND}</h3>
            </div> : ''}
        </div>
    </div>);
  }
}

ColorBoxPreview.propTypes = {
  'urlData': React.PropTypes.object,
  'block': React.PropTypes.object,
  'helperData': React.PropTypes.object,
  'shortcodeKey': React.PropTypes.number,
};

export default ColorBoxPreview;



// WEBPACK FOOTER //
// ./assets/src/frontend/preview/search/default/colorboxpreview.js